import { useTranslation } from "react-i18next";
import { Link } from "@components/Link/Link";

export const CompanyEmailLink: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement>
> = () => {
  const { t } = useTranslation();
  const companyEmail = t("common.company.email");

  return (
    <Link className="text-blue-dark" to={`mailto:${companyEmail}`}>
      {companyEmail}
    </Link>
  );
};
